import React, { forwardRef } from 'react';
import {
    Popover, Typography, Button, Link, useBreakpoint
} from '@one-thd/sui-atomic-components';

import { URLS } from '../utils/constants';
import useQueryParams from '../utils/useQueryParams.js'
import { buildURLWithParams } from '../utils/utils';


const B2cBubble = forwardRef(({ closePopover, open }, ref) => {

    const { greater: isLargeScreen } = useBreakpoint('lg');
  const [queryParams, pathName] = useQueryParams();


    return (
        <Popover
            style={{ zIndex: 1000 }}
            open={open}
            disablePortal
            id="sign-in-bubble"
            placement={isLargeScreen ? 'bottom-end' : 'top-end'}
            anchorEl={ref && ref.current ? ref.current : null}
            title="Sign in for the best experience"
            onClose={closePopover}
            data-testid="popover-component-signInTest"
            data-component="SignInBubble"
        >
            <section className="sui-mt-1 sui-mb-3">
                <Button
                    href={buildURLWithParams(pathName, queryParams, URLS.SIGN_IN_BUBBLE)}
                    variant="primary"
                    data-testid="button-component-signInTest"
                    fullWidth
                >
                    Sign In
                </Button>
            </section>

            <section className="sui-flex sui-gap-4 lg:sui-w-96">
                <Typography variant="body-xs">
                    Don&apos;t have an account?
                </Typography>
                <Link
                    variant="body-xs"
                    weight="bold"
                    data-testid="link-component-signInTest"
                    href={buildURLWithParams(pathName, queryParams, URLS.CREATE_ACCOUNT_BUBBLE)}
                >
                    Create an Account
                </Link>
            </section>

        </Popover>
    );
});

B2cBubble.displayName = 'B2cBubble';

export default B2cBubble;